import {Product} from '@/_application/modules/products/model/product';
import {mergeHighlightAndHotNewProducts} from '@/_application/modules/products/model/highlight-product';
import HighlightHotNewProductCard from '@/_application/modules/products/components/highlight-hot-new-product-card';
import {HighlightProductItem} from '@/__generated__/__types__';
import {ProductCard} from '@/_application/modules/products/components/cards/product-card';
import CustomLinkWithArrow from '@/_application/core/components/commons/custom-link-with-arrow';
import {useTranslation} from 'next-i18next';
import {Routes} from '@/config/routes';

export interface BestSellerProductsProps {
    products?: Product[];
    highlightProducts?: HighlightProductItem[];
}

function BestSellerProducts({products = [], highlightProducts = []}: BestSellerProductsProps) {
    const {t} = useTranslation('common');

    if (!products.length && !highlightProducts.length) {
        return null;
    }

    const combinedProductList = mergeHighlightAndHotNewProducts(
        highlightProducts as HighlightProductItem[],
        products as Product[],
    );

    return (
        <>
            <div className="mt-5 grid grid-cols-3 gap-5 lg:grid-cols-5">
                {highlightProducts.length > 0 &&
                    products.length > 0 &&
                    combinedProductList?.map((product, index) => (
                        <HighlightHotNewProductCard
                            amountOfHighlightProduct={highlightProducts.length}
                            productItem={product}
                            index={index}
                            key={product.id}
                        />
                    ))}
                {!highlightProducts.length &&
                    products.map(product => <ProductCard key={product?.sku} product={product as Product} />)}
            </div>
            <div className="mt-5 flex w-full items-center justify-center">
                <CustomLinkWithArrow text={t('text-view-all', 'Xem tất cả')} href={Routes.bestSeller} />
            </div>
        </>
    );
}

export default BestSellerProducts;
